import Form from '@atlaskit/form';
import { AtlassianProductHostingTypeValues } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
import { useHistory } from '@atlassian/mpac-ui';
import React, { useState } from 'react';
import { Stages } from "../constants";
import PromotionFooter from "../PromotionFooter";
import { gotoPromotionsListPage } from "./PromotionBasics.utils";
import { EligibleAppsField, EligibleAppsFieldForCloud, HostingTypeField, PromotionNameField, PromotionTypeField } from "./PromotionBasicsFormFields";

const PromotionBasics = props => {
  const onSubmit = submitData => {
    submitData.eligibleApps = hostingType.value === AtlassianProductHostingTypeValues.Cloud ? [submitData.eligibleApps] : submitData.eligibleApps;
    props.onChange(Stages.DISCOUNT_AMOUNT, submitData);
  };

  const history = useHistory();
  const promotionBasicsData = props.promotionBasicsData || {};
  const [hostingType, setHostingType] = useState(promotionBasicsData.hostingType);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "Create a promotion to let customers buy your paid via Atlassian apps at a discount. Once you have created your promotion, you will have a promo link (for Server and Data Center) or promo code (for Cloud) you can share with customers.", ' ', /*#__PURE__*/React.createElement("a", {
    href: "https://developer.atlassian.com/platform/marketplace/sales-promotions",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Learn more about promotions")), /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    novalidate: true
  }, ({
    formProps,
    getValues
  }) => /*#__PURE__*/React.createElement("form", formProps, /*#__PURE__*/React.createElement(PromotionNameField, {
    name: promotionBasicsData.name
  }), /*#__PURE__*/React.createElement(HostingTypeField, {
    hostingType: hostingType,
    partnerAppsAndHosting: props.partnerAppsAndHosting,
    setHostingType: setHostingType
  }), /*#__PURE__*/React.createElement(PromotionTypeField, {
    promotionType: promotionBasicsData.promotionType
  }), hostingType && hostingType.value === AtlassianProductHostingTypeValues.Cloud ? /*#__PURE__*/React.createElement(EligibleAppsFieldForCloud, {
    eligibleApps: promotionBasicsData.eligibleApps,
    getValues: getValues,
    partnerAppsAndHosting: props.partnerAppsAndHosting,
    hostingType: hostingType
  }) : /*#__PURE__*/React.createElement(EligibleAppsField, {
    eligibleApps: promotionBasicsData.eligibleApps,
    getValues: getValues,
    partnerAppsAndHosting: props.partnerAppsAndHosting,
    hostingType: hostingType
  }), /*#__PURE__*/React.createElement(PromotionFooter, {
    actions: [{
      text: 'Cancel',
      props: {
        onClick: () => gotoPromotionsListPage(history, {
          partnerId: props.partnerId
        })
      }
    }, {
      text: 'Next',
      props: {
        type: 'submit',
        appearance: 'primary'
      }
    }]
  }))));
};

export default PromotionBasics;